import type { QueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/lib/data/static/query-keys";

/**
 * After a successful create, signature-request lists can lag behind the API.
 * Views listening for this event can show a short loading state while the backend catches up.
 */
export const SIGNATURE_REQUEST_CREATED_EVENT =
  "lawworks:signature-request-created";

export const SIGNATURE_REQUEST_REPORT_POST_CREATE_LOADING_MS = 3000;

/**
 * Query keys invalidated immediately after a successful signature-request create
 * (`CreateSignatureRequestSlideover`). Call again after a short delay when the
 * list API may still be catching up.
 */
export async function invalidateSignatureRequestCreateRelatedQueries(
  queryClient: QueryClient,
): Promise<void> {
  await queryClient.invalidateQueries({
    queryKey: [queryKeys.matters],
  });
  await queryClient.invalidateQueries({
    queryKey: [queryKeys.firmSignatureRequests],
  });
  await queryClient.invalidateQueries({
    queryKey: [queryKeys.firmFiles],
  });
  await queryClient.invalidateQueries({
    queryKey: [queryKeys.signatureRequests],
  });
}

export function dispatchSignatureRequestCreated(): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SIGNATURE_REQUEST_CREATED_EVENT));
  }
}
